<div class="overlay" (click)="onOverlayClicked($event)">
  <div class="dialog" (click)="onDialogClicked($event)">
    <ng-template appCustomContent></ng-template>
  </div>
</div>
